import {SizeSelection_Size} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/size_selection.types';
import {useTranslation} from '@aboutyou/i18n';
import {useBasketRoute, useHistory} from '@aboutyou/router';
import {useShowToast} from '@aboutyou/ui-components';
import {useUserTokenOrSessionId} from '@aboutyou/user';
import {useEffect, useRef} from 'react';
import {SizeSource} from '../../../../../features/SizeSelection/hooks/useSelectedSizeState';

export const AUTO_ADD_TO_BASKET_LOCATION_ID = 'email_a2b';

export const useAutoAddToBasketEffect = (
  handleAddToBasket: () => Promise<boolean | void>,
  size?: SizeSelection_Size & SizeSource,
): void => {
  const history = useHistory();
  const atbCalled = useRef(false);
  const basketRoute = useBasketRoute();
  const {isLoading: isSessionLoading} = useUserTokenOrSessionId();
  const showToast = useShowToast();
  const {t} = useTranslation();

  useEffect(() => {
    if (
      atbCalled.current ||
      isSessionLoading || // add to basket instantly fails if session is not loaded
      !shouldAutoAddToBasket(history, size)
    ) {
      return;
    }

    atbCalled.current = true;
    handleAddToBasket().then(success => {
      if (success) {
        showAddToBasketSuccessToast(showToast, t);
        history.replace(basketRoute);
      }
    });
  }, [
    history,
    size,
    handleAddToBasket,
    basketRoute,
    isSessionLoading,
    showToast,
    t,
  ]);
};

export const shouldAutoAddToBasket = (
  history: ReturnType<typeof useHistory>,
  size?: SizeSelection_Size & SizeSource,
): boolean => {
  const searchParams = new URLSearchParams(history.location.search);
  return Boolean(size && searchParams.get('atb') === '1');
};

export const showAddToBasketSuccessToast = (
  showToast: ReturnType<typeof useShowToast>,
  t: ReturnType<typeof useTranslation>['t'],
) => {
  showToast({
    content: t('Successfully added to your cart!'),
    type: 'SUCCESS',
    'data-testid': 'AddToBasketSuccessToast',
  });
};
